<div class="pt-3" style="width:100%; padding-right:0px">
    <div class="main">
        <div class="header">
            <!-- Menu button enables for small screen (mobile) -->
            <div class="me-4 d-block d-md-none">
                <i class="fa fa-bars" (click)="showSideBarMenu()" style="font-size: 28px;" aria-hidden="true"></i>
            </div>
            
            <div class="iconContainer">
                <i class="fa fa-arrow-left" (click)="backIconClick()" style="cursor: pointer;"></i>
            </div>
            <div style="font-size: 20px; margin-left:15px; font-weight:600; font-family:Raleway;">Add CSE</div>
        </div>

        <div class="formContainer">
            <div>
                <app-reg-common-form [inputDataList]="inputDataList" [heading]="heading"
                    (formButtonResEvent)="formButtonResEvent($event)" formName="addCSEForm" [submitBtnText]="submitBtnText">
                </app-reg-common-form>
            </div>
        </div>
    </div>
</div>